import React from 'react';

import { Link, useLocation } from 'react-router-dom';

function BurgerMenuItem({
  path = '',
  text = '',
  activePaths = [],
  activePrefixes = [],
  variant = '',
}) {
  const location = useLocation();
  const isActive =
    location.pathname === path
    || activePaths.includes(location.pathname)
    || activePrefixes.some((prefix) => location.pathname.startsWith(prefix));
  const linkClasses = [
    'burgerMenu__link',
    isActive && 'burgerMenu__link_active',
    variant === 'accent' && 'burgerMenu__link_accent',
  ].filter(Boolean).join(' ');

  return (
    <li className="burgerMenu__item">
      <Link
        to={path}
        className={linkClasses}
      >
        {text}
      </Link>
    </li>
  );
}
export default BurgerMenuItem;
